import React from 'react';
import CalculatorLayout from './components/calculators-layout/CalculatorLayout';
import ExpandingInfo from './components/calculators-layout/ExpandingInfo';
import CalculatorForm from './components/calculators-layout/CalculatorForm';
import InputWithLabel from '../LoanApplication/components/commons/InputWithLabel';
import RepaymentYear from '../../components/RepaymentYear';
import CalculatorResultCard from './components/calculators-layout/CalculatorResultCard';
import CalculatorCallToActionCard from './components/calculators-layout/CalculatorCallToActionCard';
import Tooltip from 'react-bootstrap/Tooltip';
import {OverlayTrigger} from 'react-bootstrap';
import {returnOffsetCalculatorOutput} from './calculations/offsetCalculatorCalculations';
import currencyFormatter from '../../utils/currencyFormatter';
import monthsToYearsFormatter from '../../utils/monthsToYearsFormatter';
import fieldsToNumbers from '../../utils/fieldsToNumbers';
import ReusableGraph from './components/ReusableGraph/ReusableGraph';
import offsetCalculatorReusableGraphConfig from './components/ReusableGraph/offsetCalculatorReusableGraphConfig';
import CalculatorAssumptions from './components/calculators-layout/CalculatorAssumptions';
import OffsetAssumptionContent from './AssumptionBoxContent/OffsetAssumptionContent';
const interestRate = I18n.t('calculators.interest_matrix.live.regular.payg_variable')[0];

class OffsetCalculator extends React.Component {
  state = {
    loanAmount: 500000,
    loanTerm: 30,
    interestRate,
    startingOffsetAccountBalance: 5000,
    offsetStartsAfter: 3,
    additionalOffsetMonthlyContributions: 250,
    additionalContributionsStartAfter: 0,
    results: {
      graphData: [],
      loanTermInYears: 30,
    },
    errors: {}
  };

  onCalculationSuccess = (response) => {
    this.setState({ results: response.data })
  };

  onCalculationFailure = ({ response }) => {
    let errors = response.data.errors;

    let swalTitle = I18n.t('calculators.generic_error.title');
    let swalText = I18n.t('calculators.generic_error.description');

    if ((response.status) == 422) {
      swalTitle = I18n.t('calculators.generic_error.title');
      swalText = response.data.errors
    }

    swal({
      title: swalTitle,
      text: swalText,
      type: 'warning',
      showCancelButton: false,
      confirmButtonText: 'Close',
      allowOutsideClick: false,
      confirmButtonColor: "#10c98f",
    })
  };

  onCalculationSubmit = () => {
    const {
      loanAmount,
      loanTerm,
      interestRate,
      startingOffsetAccountBalance,
      offsetStartsAfter,
      additionalOffsetMonthlyContributions,
      additionalContributionsStartAfter
    } = this.state;
    
    const offset = {
      loanAmount,
      loanTerm,
      interestRate: interestRate / 100,
      startingOffsetAccountBalance,
      offsetStartsAfter,
      additionalOffsetMonthlyContributions,
      additionalContributionsStartAfter,
    };
    
    // let data = {
    //   offset: offset,
    // };

    let calculationResults = returnOffsetCalculatorOutput(fieldsToNumbers(offset));
    this.setState({
      results: {loanTerm, ...calculationResults},
    });

    // postOffset(
    //   data,
    //   this.onCalculationSuccess,
    //   this.onCalculationFailure
    // );
    
  };

  componentDidMount = () => {
    this.onCalculationSubmit()
  };

  expandingLead = (
    <p>The offset home loan calculator allows you to estimate how much interest you can save by keeping your savings in an offset account. The offset calculator will also help you estimate how much quicker you can pay off your home loan by using an offset account.</p>
  );
  
  expandingInfoContent = (
    <React.Fragment>
      <p>An offset account is a sub-account to your loan account that works like a transactional account. The big benefit of an offset account is that you can use it to reduce the amount of interest you pay on your loan. </p>
      <p>Your loan principal gets reduced by the amount of money you hold in your offset account for the purpose of interest calculation. For example, if your loan is $300,000 and you have $5,000 in your offset account, then interest for that month is calculated on $295,000.</p>
      <p>To start using our online offset account calculator, you should first provide your loan details - loan amount, loan term and interest rate. </p>
      <p>Then you need to provide your offset account details. You can enter a lump sum balance that you plan to put in your offset account (e.g. your savings). You can indicate whether this balance starts immediately at loan settlement or at a later date.</p>
      <p>You can also input regular additional contributions you plan to make to your offset account (e.g. net monthly savings) and also indicate their start date.</p>
      <p>The next step from here is to find a home loan with offset account for your new pruchase or to refinance your existing mortgage.</p>
    </React.Fragment>
  );

  calculatorForm() {
    const { 
      loanAmount,
      loanTerm,
      interestRate,
      startingOffsetAccountBalance,
      offsetStartsAfter,
      additionalOffsetMonthlyContributions,
      additionalContributionsStartAfter,
      errors
    } = this.state;

    const tooltip = (
      <Tooltip id="offset-calculator-tooltip">
        Your additional regular monthly contribution to the offset account
      </Tooltip>
    );
    
    return (
      <React.Fragment>
        <div className="numeric-input">
          <InputWithLabel
            label='Loan amount'
            type='currency'
            defaultValue={loanAmount}
            errorMessage={errors['loanAmount']}
            onChange={(value) => this.setState({loanAmount: value})}
          />
        </div>
        <RepaymentYear
          label='Loan term (years)'
          defaultValue={loanTerm}
          onChange={(value) => this.setState({loanTerm: value})}
        />
        <div className="rate-input">
          <InputWithLabel
            label='Interest rate'
            type='append'
            appendText={ '%' }
            defaultValue={interestRate}
            errorMessage={errors['interestRate']}
            onChange={(value) => this.setState({interestRate: value})}
          />
        </div>
        <div className="calculators-divider" />
        <div className="numeric-input">
          <InputWithLabel
            label='Starting offset account balance'
            type='currency'
            defaultValue={startingOffsetAccountBalance}
            errorMessage={errors['startingOffsetAccountBalance']}
            onChange={(value) => this.setState({startingOffsetAccountBalance: value})}
          />
        </div>
        <div className="years-text-input">
          <InputWithLabel
            type={'numberOnly'}
            label='Offset starts after'
            defaultValue={offsetStartsAfter}
            errorMessage={errors['offsetStartsAfter']}
            onChange={(value) => this.setState({offsetStartsAfter: value})}
          />
          <p>years</p>
        </div>
        <div className="calculators-divider" />
        <div className="numeric-input">
          <InputWithLabel
            label='Additional offset monthly contributions'
            type='currency'
            defaultValue={additionalOffsetMonthlyContributions}
            errorMessage={errors['additionalOffsetMonthlyContributions']}
            onChange={(value) => this.setState({additionalOffsetMonthlyContributions: value})}
          />
        </div>
        <div className="years-text-input">
          <InputWithLabel
            type={'numberOnly'}
            label={
              <span>
                Additional contributions start after
                <OverlayTrigger
                  placement="right"
                  overlay={tooltip}
                >
                  <i className="fa fa-info-circle" />
                </OverlayTrigger>
              </span>
            }
            defaultValue={additionalContributionsStartAfter}
            errorMessage={errors['additionalContributionsStartAfter']}
            onChange={(value) => this.setState({additionalContributionsStartAfter: value})}
          />
          <p>years</p>
        </div>
      </React.Fragment>
    )
  }

  resultsColumn() {
    const {results, repaymentFrequency} = this.state;
    const graphProps = {
      graphData: results.graphData,
      loanTerm: results.loanTerm,
      ...offsetCalculatorReusableGraphConfig
    }
    return results ? <div>
      <CalculatorResultCard
        caption='Interest saved'
        figure={currencyFormatter.format(this.state.results.interestSaved)}
        figureText={repaymentFrequency}
        additionalInfo={(
          <React.Fragment>
            <p>Loan repayment: <strong>{currencyFormatter.format(results.loanRepayment)} per month</strong></p>
            <p>Time saved: <strong>{monthsToYearsFormatter(results.timeSaved)}</strong></p>
            <p>New loan term: <strong>{monthsToYearsFormatter(results.newLoanTerm)}</strong></p>
          </React.Fragment>
        )}
      />
      <CalculatorCallToActionCard>
        <div className='offset-calculator__cta'>
          <p className='offset-calculator__cta-text regular-cta'>Ready to get started?</p>
        </div>
      </CalculatorCallToActionCard>
        <ReusableGraph
          graphProps={graphProps}
        />
    </div> : null;
  }
  
  render() {
    return (
      <div className="offset-calculator">
        <CalculatorLayout
          infoRow={<ExpandingInfo lead={this.expandingLead}>{this.expandingInfoContent}</ExpandingInfo>}
          formColumn={
              <CalculatorForm handleSubmit={this.onCalculationSubmit}>{this.calculatorForm()}</CalculatorForm>
          }
          resultsColumn={this.resultsColumn()}
        >
          <CalculatorAssumptions assumptionBoxContents={<OffsetAssumptionContent />} />
        </CalculatorLayout>
      </div>
    );
  }
}

export default OffsetCalculator;
